var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningPoint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 36,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 0h20a7 7 0 017 7v16a7 7 0 01-7 7h-5l-5 6-5-6H7a7 7 0 01-7-7V7a7 7 0 017-7z",
    fill: "#FF7756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.053 5.245c.409.202.743.517.957.903l8.73 15.719c.582 1.047.153 2.34-.957 2.889A2.38 2.38 0 0125.73 25H8.27C7.015 25 6 24.042 6 22.86c0-.346.089-.687.26-.993l8.73-15.72c.581-1.046 1.953-1.45 3.063-.902zm-1.54 2.938a1 1 0 00-.387.387L8.922 21.514A1 1 0 009.796 23h14.408a1 1 0 00.874-1.486L17.874 8.57a1 1 0 00-1.36-.387zM17 19a1 1 0 110 2 1 1 0 010-2zm0-8a1 1 0 011 1v5a1 1 0 01-2 0v-5a1 1 0 011-1z",
    fill: "#FFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningPoint);
export default __webpack_public_path__ + "static/media/warning-point.9fac369e.svg";
export { ForwardRef as ReactComponent };